import styles from '../styles.module.scss';
import skeleton from './styles.module.scss';
import UserPaymentDetailsCardIndicator from '../Indicator';

export default function UserPaymentDetailsCardSkeleton() {
  return (
    <div className={`${styles.card}`}>
      <div className={styles.card__row}>
        <div className={styles.card__column}>
          <h3 className={styles.card__column__label}>
            <div className={skeleton.label} />
          </h3>
          <p className={styles.card__column__description}>
            <div className={skeleton.description} />
          </p>
        </div>
        <UserPaymentDetailsCardIndicator isLoading />
      </div>
    </div>
  );
}
